// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.odsDeliveryModalHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.odsDeliveryModalLeft {
  font-weight: 600;
  color: #181d28;
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 50%;
}

.odsDeliveryModalLeftText {
  flex-shrink: 0;
}

.odsDeliveryOptionsInputWrapper {
  position: relative;
  width: 100%;
}

.odsDeliveryOptionsInputWrapper > *:first-child {
  position: absolute;
  top: 50%;
  left: 0.5rem;
  transform: translateY(-50%);
  pointer-events: none;
}

.odsDeliveryOptionsSearch {
  font-size: 0.813rem;
  padding-left: 40px;
  padding-top: 8px;
  padding-bottom: 8px;
  width: 100%;
  border: 1px solid var(--surface-g1);
  border-radius: 6px;
  color: #949494;
}

.odsDeliveryModalRight {
  display: flex;
  align-items: center;
  gap: 6px;
}

/* ── Dark theme ── */
.dark .odsDeliveryModalLeft {
  color: #f1f5f9;
}

.dark .odsDeliveryOptionsSearch {
  background-color: #1e293b;
  border-color: #334155;
  color: #f1f5f9;
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/delivery/components/OdsDeliveryTable.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,mCAAmC;EACnC,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,qBAAqB;AACrB;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB","sourcesContent":[".odsDeliveryModalHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.odsDeliveryModalLeft {\n  font-weight: 600;\n  color: #181d28;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 50%;\n}\n\n.odsDeliveryModalLeftText {\n  flex-shrink: 0;\n}\n\n.odsDeliveryOptionsInputWrapper {\n  position: relative;\n  width: 100%;\n}\n\n.odsDeliveryOptionsInputWrapper > *:first-child {\n  position: absolute;\n  top: 50%;\n  left: 0.5rem;\n  transform: translateY(-50%);\n  pointer-events: none;\n}\n\n.odsDeliveryOptionsSearch {\n  font-size: 0.813rem;\n  padding-left: 40px;\n  padding-top: 8px;\n  padding-bottom: 8px;\n  width: 100%;\n  border: 1px solid var(--surface-g1);\n  border-radius: 6px;\n  color: #949494;\n}\n\n.odsDeliveryModalRight {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n/* ── Dark theme ── */\n.dark .odsDeliveryModalLeft {\n  color: #f1f5f9;\n}\n\n.dark .odsDeliveryOptionsSearch {\n  background-color: #1e293b;\n  border-color: #334155;\n  color: #f1f5f9;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
